import React, { useState, useEffect } from 'react';
import ChildHeader from '../../Dashboard/Main/ChildHeader';
import { Text, Button, VStack, Heading, Stack, HStack, chakra, Center, Alert, AlertIcon, useDisclosure, Box } from '@chakra-ui/react';
import { MdPendingActions } from 'react-icons/md';
import BottomNavBar from 'components/BottomNavBar';
import { useLocation } from 'react-router-dom';
import CopyToClipboard from 'react-copy-to-clipboard';
import { MdCreditCard } from 'react-icons/md';
import ModalDesmarcarReserva from './ModalDesmarcarReserva';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
const EMPTY_ATTENDIMENTO = {};

function DetalhesEmAnalise() {
  const { state } = useLocation();
  const atendimentoState = state?.atendimento || EMPTY_ATTENDIMENTO;
  const [atendimento, setAtendimento] = useState(atendimentoState);
  const [codigoPix, setCodigoPix] = useState('carregando');
  const [copy, setCopy] = useState(false);
  const [valorPendente, setValorPendente] = useState(0);
  const buttonDesmarcar = state?.desmarcar_reserva;
  const [formaPagamento, setFormaPagamento] = useState();

  function myToLowerCase(text) {
    if (typeof text === 'string') {
      return text.toLocaleLowerCase();
    } else {
      return text;
    }
  }

  const parseJsonArray = (value) => {
    if (Array.isArray(value)) return value;
    if (!value || typeof value !== 'string') return [];

    try {
      const parsedValue = JSON.parse(value);

      return Array.isArray(parsedValue) ? parsedValue : [];
    } catch {
      return [];
    }
  };

  const capitalizeFirstLetter = (string) => {
    if (!string || typeof string !== 'string') return string;

    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const parseDateValue = (value) => {
    if (!value) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

    if (typeof value === 'string') {
      const [datePart] = value.split(/[T ]/);
      const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);

      if (match) {
        const [, year, month, day] = match;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const formatDateForDisplay = (value) => {
    const date = parseDateValue(value);

    if (!date) return null;

    const weekDay = capitalizeFirstLetter(date.toLocaleDateString('pt-br', { weekday: 'long' }));
    const dateText = date.toLocaleDateString('pt-br', { day: '2-digit', month: '2-digit', year: 'numeric' });

    return `${weekDay}, ${dateText}`;
  };

  const formatTimeForDisplay = (value) => {
    if (!value) return null;

    const [hour, minute] = String(value).split(':');

    if (!hour || !minute) return String(value);

    return `${hour}:${minute}h`;
  };

  const getPeriodForDisplay = (value) => {
    if (!value) return '';

    const [hour, minute = '0'] = String(value).split(':');
    const hourNumber = Number(hour);
    const minuteNumber = Number(minute);

    if (Number.isNaN(hourNumber) || Number.isNaN(minuteNumber)) return '';

    return hourNumber * 60 + minuteNumber > 12 * 60 ? 'Tarde' : 'Manhã';
  };

  const getDateKey = (value) => {
    const date = parseDateValue(value);

    if (!date) return '9999-99-99';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const isTruthy = (value) => {
    return value === true || value === 'true' || value === 1 || value === '1';
  };

  const splitProcedureNameStatus = (procedure) => {
    const [procedureName, procedureStatus] = String(procedure).split(' -> ');

    return {
      procedureName: procedureName?.trim(),
      procedureStatus: procedureStatus?.trim(),
    };
  };

  const getProcedureDetailsList = (appointment) => {
    return parseJsonArray(appointment?.DADOS_GERAIS_EXAMES);
  };

  const getProcedureDetails = (appointment, procedureName, index) => {
    const details = getProcedureDetailsList(appointment);
    const procedureScheduleId = parseJsonArray(appointment?.agenda_id_multiprocedimento)[index];
    const detailByScheduleId = details.find((procedure) => String(procedure?.agenda_exames_id || '') === String(procedureScheduleId || ''));

    return (
      detailByScheduleId ||
      details.find(
        (procedure) =>
          String(procedure?.nome || '')
            .trim()
            .toLowerCase() ===
          String(procedureName || '')
            .trim()
            .toLowerCase(),
      ) ||
      details[index] ||
      null
    );
  };

  const getProcedureScheduleParts = (procedureDetails, useAttendanceFallback = true) => {
    const dateValue = procedureDetails?.dia_selecionado || procedureDetails?.APP_DATE || (useAttendanceFallback ? atendimento?.APP_DATE : null);
    const dateText = formatDateForDisplay(dateValue);
    const hourValue =
      procedureDetails?.horario ||
      procedureDetails?.hora_selecionada_display ||
      procedureDetails?.START_TIME ||
      (useAttendanceFallback ? atendimento?.START_TIME : null);
    const hourText = formatTimeForDisplay(hourValue);
    const isByOrder =
      isTruthy(procedureDetails?.agenda_ordem_chegada) || isTruthy(procedureDetails?.isByOrder) || isTruthy(atendimento?.ordem_chegada);
    const periodText = getPeriodForDisplay(hourValue);
    const detailText = isByOrder
      ? `${periodText ? `${periodText} — ` : ''}Ordem de chegada`
      : hourText
        ? `${periodText ? `${periodText} — ` : ''}${hourText}`
        : null;

    return {
      dateText,
      detailText,
      dateKey: getDateKey(dateValue),
      sortTime: hourValue || '99:99',
      scheduleKey: isByOrder ? `order-${periodText || 'periodo'}` : hourValue || 'sem-horario',
    };
  };

  const getProcedureScheduleText = (procedureDetails, useAttendanceFallback = true) => {
    const { dateText, detailText } = getProcedureScheduleParts(procedureDetails, useAttendanceFallback);

    if (dateText && detailText) return `${dateText}\n${detailText}`;
    if (dateText) return dateText;
    if (detailText) return detailText;

    return null;
  };

  const getAttendanceScheduleText = () => {
    const firstProcedureDetails = getProcedureDetailsList(atendimento)[0] || null;

    return getProcedureScheduleText(firstProcedureDetails) || 'Data e horário não informados';
  };

  const getProcedureDoctorName = (procedureDetails) => {
    return String(procedureDetails?.medico_nome || '').trim();
  };

  const isBlankDoctorName = (doctorName) => {
    const normalizedDoctorName = String(doctorName || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

    return !normalizedDoctorName || normalizedDoctorName === 'sem solicitante';
  };

  const getUniqueProcedureDoctorNames = (procedureItems) => {
    const uniqueDoctors = [];

    procedureItems.forEach((procedureItem) => {
      if (isBlankDoctorName(procedureItem.doctorName)) return;

      const normalizedDoctorName = procedureItem.doctorName.toLowerCase();
      const alreadyExists = uniqueDoctors.some((doctorName) => doctorName.toLowerCase() === normalizedDoctorName);

      if (!alreadyExists) uniqueDoctors.push(procedureItem.doctorName);
    });

    return uniqueDoctors;
  };

  const getProcedureGroups = (procedureItems) => {
    const groups = new Map();

    procedureItems.forEach((procedureItem, index) => {
      const isDoctorDependent = !isBlankDoctorName(procedureItem.doctorName) || Boolean(procedureItem.doctorId);
      const doctorDisplayName = isDoctorDependent
        ? isBlankDoctorName(procedureItem.doctorName)
          ? 'Profissional não informado'
          : procedureItem.doctorName
        : '';
      const doctorKey = isDoctorDependent ? procedureItem.doctorId || doctorDisplayName || `medico-nao-informado-${index}` : 'sem-medico';
      const groupKey = isDoctorDependent
        ? `${procedureItem.schedule.dateKey}|medico|${doctorKey}|${procedureItem.schedule.scheduleKey}`
        : `${procedureItem.schedule.dateKey}|sem-medico|${procedureItem.schedule.scheduleKey}`;

      if (!groups.has(groupKey)) {
        groups.set(groupKey, {
          key: groupKey,
          dateText: procedureItem.schedule.dateText,
          detailText: procedureItem.schedule.detailText,
          dateKey: procedureItem.schedule.dateKey,
          sortTime: procedureItem.schedule.sortTime,
          firstIndex: index,
          doctorDisplayName,
          isDoctorDependent,
          procedures: [],
        });
      }

      groups.get(groupKey).procedures.push(procedureItem);
    });

    return Array.from(groups.values()).sort((a, b) => {
      if (a.dateKey !== b.dateKey) return a.dateKey.localeCompare(b.dateKey);
      if (a.isDoctorDependent !== b.isDoctorDependent) return a.isDoctorDependent ? 1 : -1;
      if (a.sortTime !== b.sortTime) return a.sortTime.localeCompare(b.sortTime);
      return a.firstIndex - b.firstIndex;
    });
  };

  const fetchMultiprocedureDetails = async (appointment) => {
    const currentDetails = getProcedureDetailsList(appointment);
    const procedureScheduleIds = parseJsonArray(appointment?.agenda_id_multiprocedimento).filter(Boolean);
    const procedureNames = Array.isArray(appointment?.PROCEDURE_NAMES) ? appointment.PROCEDURE_NAMES : [];
    const hasCurrentProcedureDetails =
      currentDetails.length > 0 &&
      currentDetails.length >= procedureNames.length &&
      currentDetails.every(
        (procedure) =>
          (procedure?.dia_selecionado || procedure?.APP_DATE) &&
          Object.prototype.hasOwnProperty.call(procedure, 'medico_id') &&
          Object.prototype.hasOwnProperty.call(procedure, 'medico_nome'),
      );

    if (hasCurrentProcedureDetails || procedureScheduleIds.length === 0) return appointment;

    const details = await Promise.all(
      procedureScheduleIds.map(async (scheduleId, index) => {
        try {
          const response = await api(`${ENDPOINT}/appointments/fetchDetalhesAppointment/${scheduleId}`, {
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            method: 'GET',
          });
          const postsData = await response.json();
          const appointmentDetails = Array.isArray(postsData) ? postsData[0] : postsData?.appointments?.[0];
          const { procedureName } = splitProcedureNameStatus(appointment?.PROCEDURE_NAMES?.[index]);

          if (!appointmentDetails) return null;

          const medicoId = Number(appointmentDetails.RESOURCE_LID);
          const hasMedico = medicoId && ![0, 50164].includes(medicoId);

          return {
            nome: appointmentDetails.ACTIVITY_NAME || procedureName,
            dia_selecionado: appointmentDetails.APP_DATE,
            APP_DATE: appointmentDetails.APP_DATE,
            horario: appointmentDetails.START_TIME,
            hora_selecionada_display: appointmentDetails.START_TIME,
            START_TIME: appointmentDetails.START_TIME,
            agenda_exames_id: appointmentDetails.APP_LID || Number(scheduleId),
            procedimento_tuss_id: appointmentDetails.procedimento_tuss_id,
            medico_id: hasMedico ? medicoId : null,
            medico_nome: hasMedico ? appointmentDetails.RESOURCE_NAME : null,
            agenda_ordem_chegada: appointmentDetails.ordem_chegada,
          };
        } catch {
          return null;
        }
      }),
    );

    const hydratedDetails = details.map((detail, index) => detail || currentDetails[index]).filter(Boolean);

    return {
      ...appointment,
      DADOS_GERAIS_EXAMES: hydratedDetails.length > 0 ? hydratedDetails : currentDetails,
    };
  };

  const fetchAppointments = async (agenda_id) => {
    const url = `${ENDPOINT}/appointments/pending-payment/${buttonDesmarcar ? atendimento.APP_LID : agenda_id}`;
    console.log('url', url);
    const response = await api(url, {
      headers: { 'Content-Type': 'application/json' },
      method: 'GET',
    });
    const postsData = await response.json();
    if (postsData) {
      setFormaPagamento(postsData?.forma_pagamento ? postsData?.forma_pagamento : undefined);
      setCodigoPix(postsData?.metadata?.pix_code ? postsData?.metadata?.pix_code : '');
      setValorPendente(postsData.valor);
    }
  };

  const fetchAppointmentsexame = async (financeiro_faturas_pendentes_app_id) => {
    const url = `${ENDPOINT}/appointments/pending-paymentexame/${financeiro_faturas_pendentes_app_id}`;
    const response = await api(url, {
      headers: { 'Content-Type': 'application/json' },
      method: 'GET',
    });
    const postsData = await response.json();
    setFormaPagamento(postsData?.forma_pagamento ? postsData?.forma_pagamento : undefined);
    setCodigoPix(postsData?.metadata?.pix_code ? postsData?.metadata?.pix_code : '');
  };

  useEffect(() => {
    let isMounted = true;

    async function hydrateAtendimento() {
      const hydratedAppointment = await fetchMultiprocedureDetails(atendimentoState);

      if (isMounted) setAtendimento(hydratedAppointment);
    }

    hydrateAtendimento();

    return () => {
      isMounted = false;
    };
  }, [atendimentoState]);

  useEffect(() => {
    if (!atendimento?.APP_LID && !atendimento?.financeiro_faturas_pendentes_app_id) return;

    if (atendimento.financeiro_faturas_pendentes_app_id) {
      fetchAppointmentsexame(atendimento.financeiro_faturas_pendentes_app_id);
    } else {
      fetchAppointments(atendimento.APP_LID);
    }
  }, [atendimento?.APP_LID, atendimento?.financeiro_faturas_pendentes_app_id, buttonDesmarcar]);

  const modalCancelamento = useDisclosure();

  const procedureNames = Array.isArray(atendimento?.PROCEDURE_NAMES) ? atendimento.PROCEDURE_NAMES : [];
  const showProcedureDates = procedureNames.length > 1;
  const procedureItems = procedureNames.map((procedure, index) => {
    const { procedureName, procedureStatus } = splitProcedureNameStatus(procedure);
    const procedureDetails = getProcedureDetails(atendimento, procedureName, index);
    const schedule = getProcedureScheduleParts(procedureDetails, !showProcedureDates);

    return {
      itemKey: `${procedureName}-${index}`,
      doctorId: procedureDetails?.medico_id,
      doctorName: getProcedureDoctorName(procedureDetails),
      procedureName,
      procedureStatus,
      schedule,
    };
  });
  const procedureGroups = showProcedureDates ? getProcedureGroups(procedureItems) : [];
  const shouldShowDoctorInProcedureGroups = procedureGroups.some((group) => group.doctorDisplayName);
  const resourceDoctorName = String(atendimento?.RESOURCE_NAME || '').trim();
  const uniqueProcedureDoctorNames = getUniqueProcedureDoctorNames(procedureItems);
  const shouldUseProcedureDoctorAtTop =
    !shouldShowDoctorInProcedureGroups && isBlankDoctorName(resourceDoctorName) && uniqueProcedureDoctorNames.length === 1;
  const cardDoctorText = shouldShowDoctorInProcedureGroups
    ? ''
    : shouldUseProcedureDoctorAtTop
      ? myToLowerCase(uniqueProcedureDoctorNames[0])
      : isBlankDoctorName(resourceDoctorName)
        ? ''
        : (atendimento?.GENDER === 'F' ? 'Dra. ' : 'Dr. ') + myToLowerCase(resourceDoctorName);

  const renderProcedureItem = ({ itemKey, procedureName, procedureStatus }) => {
    return (
      <Box key={itemKey} mb="0.5">
        <Text fontWeight="bold" fontSize="0.8em">
          {procedureName}
        </Text>
        {procedureStatus === 'FINALIZADO' ? (
          <Text color="teal" fontSize="0.8em" fontWeight="semibold">
            Realizado
          </Text>
        ) : (
          <></>
        )}
      </Box>
    );
  };

  const useListProcedures = showProcedureDates
    ? procedureGroups.map((group, index) => (
        <Box key={group.key} pt={index === 0 ? 0 : 2} mt={index === 0 ? 0 : 2} borderTop={index === 0 ? 'none' : '1px solid'} borderColor="gray.100">
          {group.doctorDisplayName ? (
            <Text fontSize="0.78em" fontWeight="semibold" color="gray.600" mb="1" casing="capitalize">
              {myToLowerCase(group.doctorDisplayName)}
            </Text>
          ) : (
            <></>
          )}
          {group.procedures.map(renderProcedureItem)}
          <Box mt="1">
            <Text color="gray.500" fontSize="0.8em" fontWeight="semibold">
              {group.dateText || 'Data não informada'}
            </Text>
            {group.detailText ? (
              <Text color="gray.500" fontSize="0.8em" fontWeight="semibold">
                {group.detailText}
              </Text>
            ) : (
              <></>
            )}
          </Box>
        </Box>
      ))
    : procedureItems.map(renderProcedureItem);

  const appointmentTitle = atendimento.financeiro_faturas_pendentes_app_id
    ? 'Agendamento de exames'
    : atendimento?.ACTIVITY_NAME
      ? atendimento?.ACTIVITY_NAME
      : 'CONSULTA COM ' + atendimento?.ESPECIALIDADE?.toUpperCase();
  const pendingValue = valorPendente ? valorPendente : atendimento.PRICE;

  const renderAppointmentSummary = ({ borderColor, minW = '100%', maxW = '800px', showValue = false } = {}) => (
    <Center>
      <Stack
        borderWidth="1px"
        borderRadius="20px"
        borderColor={borderColor}
        minW={minW}
        maxW={maxW}
        direction={{ base: 'column', md: 'row' }}
        bg="white"
        boxShadow="lg"
        padding={4}
      >
        <VStack alignItems="stretch" spacing={3} w="100%">
          <Heading fontSize="sm">{appointmentTitle}</Heading>
          {!shouldShowDoctorInProcedureGroups && cardDoctorText ? (
            <Text fontSize="0.8em" fontWeight="semibold" casing="capitalize">
              {cardDoctorText}
            </Text>
          ) : (
            <></>
          )}
          <chakra.p fontSize="0.8em">
            <chakra.span fontWeight="bold">Modalidade: </chakra.span>
            {atendimento.atendimento_telemed === true || state?.desmarcar_reserva === true ? 'Telemedicina' : 'Presencial'}
          </chakra.p>
          {!showProcedureDates ? (
            <chakra.p fontSize="0.8em" whiteSpace="pre-line">
              <chakra.span fontWeight="bold">Data do atendimento: </chakra.span>
              {getAttendanceScheduleText()}
            </chakra.p>
          ) : (
            <></>
          )}
          {procedureNames.length > 0 ? (
            <Box pt="2" borderTop="1px solid" borderColor="gray.100">
              <chakra.p fontSize="0.8em" mb="1">
                <chakra.span fontWeight="bold">Procedimento{procedureNames.length > 1 ? 's' : ''}: </chakra.span>
              </chakra.p>
              <Box>{useListProcedures}</Box>
            </Box>
          ) : (
            <></>
          )}
          {showValue ? (
            <chakra.p fontSize="0.8em">
              <chakra.span fontWeight="bold">Valor: </chakra.span>
              R$ {pendingValue}
            </chakra.p>
          ) : (
            <></>
          )}
        </VStack>
      </Stack>
    </Center>
  );

  return formaPagamento ? (
    formaPagamento === 'pix' ? (
      <>
        <ChildHeader />
        <ModalDesmarcarReserva disclosure={modalCancelamento} agenda_exames_id={atendimento.APP_LID} />
        <VStack
          align="center"
          justify={{
            base: 'center',
            md: 'space-around',
            xl: 'space-between',
          }}
          direction={{ base: 'column-reverse' }}
          wrap="no-wrap"
          spacing={4}
          px={8}
          py={4}
        >
          <Stack direction="row" align="center">
            <Heading fontSize="lg">Processando Pagamento</Heading>
            <MdPendingActions size="50" />
          </Stack>

          {renderAppointmentSummary({ borderColor: 'yellow.400', minW: '105%', showValue: true })}

          <Alert status="info" minW="80%" maxW="310px" fontSize="xs" borderRadius={20}>
            <AlertIcon />
            <Text fontSize="10">Caso ainda não tenha realizado o pagamento pague usando o codigo pix abaixo.</Text>
          </Alert>

          <HStack w="100%" textAlign="center">
            <Text w="100%" fontWeight="bold">
              Código Pix Copia e Cola
            </Text>
          </HStack>
          <HStack w="100%" textAlign="center">
            <Text w="100%" fontSize="12">
              {codigoPix?.substring(0, 80) + '...'}
            </Text>
          </HStack>

          <CopyToClipboard text={codigoPix} onCopy={() => setCopy(true)}>
            <Button name="copy" colorScheme="teal" w="90%" variant="outline">
              {copy ? 'Copiado!' : 'Copiar'}
            </Button>
          </CopyToClipboard>
          {buttonDesmarcar && (
            <Button
              bg="red.500"
              color={'white'}
              w={'90%'}
              onClick={() => {
                modalCancelamento.onOpen();
              }}
            >
              Desmarcar reserva
            </Button>
          )}

          <chakra.span textAlign="center" fontSize="sm" fontWeight="bold">
            O código acima tem validade de 30 minutos.
          </chakra.span>
          <Center>
            {' '}
            <chakra.span textAlign="center" fontSize="xs" fontWeight="bold" color="red">
              Caso o pagamento não seja realizado no prazo estipulado a sua aquisição será cancelada.
            </chakra.span>
          </Center>
          <VStack>
            <Stack direction="column" mb="12">
              <Text textAlign="center" fontSize="0.9em">
                Problemas com seu agendamento?
              </Text>
              <Button
                colorScheme="teal"
                borderRadius={8}
                height="40px"
                onClick={() => {
                  window?.ReactNativeWebView?.postMessage(
                    JSON.stringify({
                      service: true,
                      openInBrowser: true,
                      url: 'https://wa.me/5508002802133',
                    }),
                  );
                }}
                width="350px"
                variant="ghost"
              >
                Falar com Suporte
              </Button>
            </Stack>
          </VStack>
        </VStack>

        <BottomNavBar />
      </>
    ) : (
      <>
        <ModalDesmarcarReserva disclosure={modalCancelamento} agenda_exames_id={atendimento.APP_LID} />
        <ChildHeader />
        <VStack
          align="center"
          justify={{
            base: 'center',
            md: 'space-around',
            xl: 'space-between',
          }}
          direction={{ base: 'column-reverse' }}
          wrap="no-wrap"
          spacing={5}
          px={4}
          py={6}
        >
          <Stack direction="row" align="center">
            <Heading fontSize="lg">Processando Pagamento</Heading>
            <MdCreditCard size="50" />
          </Stack>
          <Center>
            {' '}
            <Text alignItems="center">O pagamento de: </Text>
          </Center>

          {renderAppointmentSummary({ maxW: '500px' })}

          <Center>
            {' '}
            <Text alignItems="center">Está em processamento </Text>
          </Center>

          <chakra.span textAlign="center" fontSize="xs" fontWeight="bold" color="yellow.500"></chakra.span>
          <Stack>
            <Alert status="info" fontSize="xs" borderRadius={20}>
              <AlertIcon />
              <Text noOfLines={1} fontSize="10">
                Após a confirmação do pagamento você será notificado!
              </Text>
            </Alert>
          </Stack>
          <chakra.span textAlign="center" fontSize="xs" fontWeight="bold" color="red">
            Caso o pagamento não seja realizado no prazo estipulado a sua aquisição será cancelada.
          </chakra.span>
          {buttonDesmarcar && (
            <Button
              bg="red.500"
              color={'white'}
              w={'90%'}
              onClick={() => {
                modalCancelamento.onOpen();
              }}
            >
              Desmarcar reserva
            </Button>
          )}
        </VStack>
        <VStack mt="3" mb="15%">
          <Stack direction="column" spacing={2}>
            <Text textAlign="center" fontSize="0.9em">
              Problemas com seu agendamento?
            </Text>
            <Button
              colorScheme="teal"
              borderRadius={8}
              height="40px"
              onClick={() => {
                window?.ReactNativeWebView?.postMessage(
                  JSON.stringify({
                    service: true,
                    openInBrowser: true,
                    url: 'https://wa.me/5508002802133',
                  }),
                );
              }}
              width="350px"
              variant="ghost"
            >
              Falar com Suporte
            </Button>
          </Stack>
        </VStack>
        <BottomNavBar />
      </>
    )
  ) : (
    <>
      <ChildHeader />
      <ModalDesmarcarReserva disclosure={modalCancelamento} agenda_exames_id={atendimento.APP_LID} />
      <VStack
        align="center"
        justify={{
          base: 'center',
          md: 'space-around',
          xl: 'space-between',
        }}
        direction={{ base: 'column-reverse' }}
        wrap="no-wrap"
        spacing={4}
        px={8}
        py={4}
      >
        <Stack direction="row" align="center">
          <Heading fontSize="lg">Processando Pagamento</Heading>
          <MdPendingActions size="50" />
        </Stack>

        {renderAppointmentSummary({ borderColor: 'yellow.400', minW: '105%', showValue: true })}
        <Center>
          {' '}
          <chakra.span textAlign="center" fontSize="xs" fontWeight="bold" color="red">
            Caso o pagamento não seja realizado no prazo estipulado a sua aquisição será cancelada.
          </chakra.span>
        </Center>
        <VStack>
          <Stack direction="column" mb="12">
            <Text textAlign="center" fontSize="0.9em">
              Problemas com seu agendamento?
            </Text>
            <Button
              colorScheme="teal"
              borderRadius={8}
              height="40px"
              onClick={() => {
                window?.ReactNativeWebView?.postMessage(
                  JSON.stringify({
                    service: true,
                    openInBrowser: true,
                    url: 'https://wa.me/5508002802133',
                  }),
                );
              }}
              width="350px"
              variant="ghost"
            >
              Falar com Suporte
            </Button>
          </Stack>
        </VStack>
      </VStack>

      <BottomNavBar />
    </>
  );
}

export default DetalhesEmAnalise;
